<template>

    <div class="podium__screen noselect">

        <markdown class="podium__title" :text="computedText" :color="'#3a4f41'"></markdown>

        <div class="podium__bottom__container">

            <div class="podium__bottom__bloc podium__bottom__bloc-second">

                <img src="/img/stories/stories-podium-shadow.svg" class="podium__bottom__shadow">

                <p class="podium__bottom__text">{{ computedSecondPlace | capitalizeFirstLetter }}</p>

                <span class="podium__bottom__number">2</span>

            </div>

            <div class="podium__bottom__bloc podium__bottom__bloc-first">

                <img src="/img/stories/stories-podium-shadow.svg" class="podium__bottom__shadow">

                <p class="podium__bottom__text">{{ computedFirstPlace | capitalizeFirstLetter }}</p>

                <span class="podium__bottom__number">1</span>

            </div>

            <div class="podium__bottom__bloc podium__bottom__bloc-third">

                <img src="/img/stories/stories-podium-shadow.svg" class="podium__bottom__shadow">

                <p class="podium__bottom__text">{{ computedThirdPlace | capitalizeFirstLetter }}</p>

                <span class="podium__bottom__number">3</span>

            </div>


        </div>


    </div>

</template>

<script>

import Markdown from '@/components/Markdown'

export default {

    name: 'podium',

    components: { Markdown },

    computed: {

        computedText: function () {
            return this.$tc('stories_screen_6_text', 0, { category: this.getCategoryName(this.data.value[0].category), percentage: this.data.value[0].amount })
        },

        computedFirstPlace: function () {
            return this.getCategoryName(this.data.value[0].category)
        },

        computedSecondPlace: function () {
            return this.getCategoryName(this.data.value[1].category)
        },

        computedThirdPlace: function () {
            return this.getCategoryName(this.data.value[2].category)
        }
    },

    props: {

        data: {
            type: Object,
            default: () => {}
        }
    },

    methods: {

        getCategoryName(category) {

            switch (category) {
                case 'SPORT':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_sport'))
                case 'FOOD':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_groceries'))
                case 'POT':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_money_pots'))
                case 'CULTURE_LEISURE':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_culture_entertainment'))
                case 'MARKETPLACE':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_marketplace'))
                case 'HIGH_TECH':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_high_tech'))
                case 'GAMES':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_games'))
                case 'FOOD_DELIVERY':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_meal_delivery'))
                case 'HOME':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_home'))
                case 'FASHION':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_fashion'))
                case 'HEALTH':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_health'))
                case 'TELEPHONY':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_phone'))
                case 'TRANSPORT':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_transportation'))
                case 'TRAVEL':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_travel'))
                case 'VTC_CAB':
                    return this.capitalizeFirstLetter(this.$t('stories_catg_vtc&taxis'))
                default:
                    this.close()
            }

        },

        capitalizeFirstLetter(string) {
            if (string) {
                string = string.toString()
                return string.charAt(0).toUpperCase() + string.slice(1)
            }
            return ''
        },

        close() {
            this.$emit('close')
        }
    }

}

</script>

<style scoped lang="scss">

    .podium {
        &__screen {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 100%;
            background-color: $forest;
            color: $sand;
            padding: 98px 24px 0;
        }

        &__title {
            font-size: 22px;
            font-weight: bold;
            text-align: center;
        }

        &__bottom {

            &__container {
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: space-between;
                overflow: hidden;
                width: 100%;
                padding-left: 32px;
            }

            &__bloc {
                position: relative;
                width: 30%;
                background-color: $sand;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: start;
                z-index: 1;
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }

            &__bloc-first {
                min-height: 50vh;
                z-index: 2;
            }

            &__bloc-second {
                min-height: 40vh;
                z-index: 3;
            }

            &__bloc-third {
                min-height: 30vh;
            }

            &__shadow {
                width: 32px;
                object-fit: contain;
                position: absolute;
                top: 2px;
                left: -32px;
            }

            &__text {
                font-size: 11px;
                color: $forest;
                margin-top: 16px;
                width: 100%;
                padding: 0 4px;
                word-wrap: break-word;
            }

            &__number {
                font-size: 64px;
                font-weight: bold;
                margin-top: 24px;
                color: $rifle;
            }
        }
    }

</style>

